import { Modal } from "@scandotcom/react";
import React, { ComponentProps } from "react";
import type { LocationResult, ScanType } from "../types";
import { AvailabilitySlot } from "./useAvailabilitySlots";
import { ConfirmationModalContent } from "./ConfirmationModalContent";

interface ModalProps extends Omit<ComponentProps<typeof Modal>, "children"> {
  location: Pick<
    LocationResult,
    "id" | "name" | "next_day_surcharge" | "price"
  >;
  modality: ScanType;
  bodyPartIds: number[];
  slot: AvailabilitySlot | null;
  onConfirm: () => void;
  hidePrices?: boolean;
}

export function ConfirmationModal({
  onClose,
  location,
  bodyPartIds,
  modality,
  slot,
  onConfirm,
  hidePrices,
  ...props
}: ModalProps) {
  return (
    <Modal
      {...props}
      onClose={onClose}
      transition="left"
      className="flex min-h-full flex-col gap-4 sm:min-h-0 sm:min-w-[440px] sm:max-w-md"
    >
      <Modal.Header onClose={onClose} type="back">
        <h2 className="sm:mr-auto">Request an appointment</h2>
      </Modal.Header>

      {slot ? (
        <ConfirmationModalContent
          location={location}
          slot={slot}
          bodyPartIds={bodyPartIds}
          modality={modality}
          onClose={onClose}
          onConfirm={onConfirm}
          hidePrices={hidePrices}
        />
      ) : null}
    </Modal>
  );
}
